export class GlobalVariable {
    _dealersState = null;
    setDealersState(state) {
        this._dealersState = state;
    }

    getDealersState() {
        return this._dealersState;
    }
}
const globalVariable = new GlobalVariable();

export default globalVariable;